import { useQuery, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';
import { QUERY_KEY as ENROLLEMENT_QUERY_KEY } from '@/modules/transaction/hooks/useMyEnrollments';
export enum CipVerificationStatus {
  Success = 'PASS',
  Pending = 'PENDING',
  Error = 'FAIL',
}

interface CipResponse {
  status: CipVerificationStatus;
}

const QUERY_KEY = 'GET_CIP_VERIFICATION_STATUS';
export default () => {
  const queryClient = useQueryClient();
  const {
    refetch: handleCheck,
    isLoading,
    isError,
    // TODO: Return type is not exists
  } = useQuery([QUERY_KEY], () => api.get<CipResponse>(API_URL.IDOLOGY_DOCUMENT_PROCESS_STATUS), {
    enabled: false,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ENROLLEMENT_QUERY_KEY],
      });
    },
  });

  return {
    handleCheck,
    isLoading,
    isError,
  };
};
